import React, { lazy } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import GraphContainer from '../../GraphContainer'
import { socialReturnOnInvestmentReportSelector } from '../../../../../../modules/selectors/socialReturnOnInvestment'

import { gridCharts } from '../../../constants'
import { COUNTRY_ID } from '../../../forms/fields'

const SaudiArabiaMap = lazy(() => import('./maps/SaudiArabiaMap'))

const ImpactByRegion = () => {
  const { t } = useTranslation()

  const { [COUNTRY_ID]: countryOfOperation } = useSelector(socialReturnOnInvestmentReportSelector)

  return (
    <GraphContainer id={gridCharts.sroiImpactByRegion} title={t('Impact by Region')}>
      {countryOfOperation === 'SAU' && <SaudiArabiaMap />}
    </GraphContainer>
  )
}

export default ImpactByRegion
